import * as React from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function AlertIllustration() {
  return _jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    fill: "none",
    children: [_jsxs("g", {
      clipPath: "url(#a)",
      children: [_jsx("path", {
        fill: "#E6EFFF",
        d: "M136.223 62.904c11.723 29.743-2.169 62.376-33.418 74.692-31.25 12.316-68.574-11.316-80.297-41.06-11.722-29.742 9.82-59.299 36.892-69.07 28.902-10.43 65.101 5.695 76.823 35.438Z"
      }), _jsx("path", {
        fill: "#FFC85C",
        d: "M74.918 22.581c2.616-4.303 8.862-4.303 11.478 0l57.847 95.186c2.72 4.475-.501 10.202-5.738 10.202H22.81c-5.237 0-8.459-5.727-5.74-10.202l57.848-95.186Z"
      }), _jsx("path", {
        fill: "#F2964B",
        fillRule: "evenodd",
        d: "m107.993 58.119 36.25 59.647c2.719 4.476-.502 10.203-5.739 10.203H61.607l46.386-69.85Z",
        clipRule: "evenodd"
      }), _jsx("path", {
        stroke: "#B75327",
        strokeWidth: 2.686,
        d: "M24.25 127.298h110.13"
      }), _jsx("circle", {
        cx: 80.312,
        cy: 103.468,
        r: 6.371,
        fill: "#fff"
      }), _jsx("path", {
        fill: "#fff",
        d: "M74.365 66.502a5.96 5.96 0 1 1 11.894 0l-1.417 21.26a4.54 4.54 0 0 1-9.06 0l-1.417-21.26Z"
      })]
    }), _jsx("defs", {
      children: _jsx("clipPath", {
        id: "a",
        children: _jsx("path", {
          fill: "#fff",
          d: "M.656 0h160v160h-160z"
        })
      })
    })]
  });
}